import { assertEnabledApi } from '../util';
var FlowAPI = /** @class */ (function () {
    function FlowAPI(_a) {
        var httpClient = _a.httpClient;
        this.reportError = function (error) {
            console.warn("You are trying to report an error, but didn't configure sentry in `.application.json`\n\nPlease read the docs for more information https://bo.wix.com/pages/yoshi/docs/editor-flow/structure-api/app-configuration/#applicationjson", 'Error: ', error);
            return undefined;
        };
        this._httpClient = httpClient;
    }
    Object.defineProperty(FlowAPI.prototype, "httpClient", {
        get: function () {
            var _httpClient = this._httpClient;
            assertEnabledApi(_httpClient, 'HttpClient');
            return _httpClient;
        },
        enumerable: false,
        configurable: true
    });
    return FlowAPI;
}());
export { FlowAPI };
//# sourceMappingURL=Base.js.map